import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { scrollToElement } from 'yoda-checkout-components/lib/helpers/Utils/ATCCommonUtils';
import { navigateToPDPPageWithoutParams } from 'yoda-checkout-components/lib/helpers/Utils/Utils';
import { dt } from 'yoda-core-components/lib/helpers/Utils/GetTailwindToken';

export default class RemovedCartItemMessage extends React.PureComponent {
    static defaultProps = {
        removedItem: {},
    };

    static propTypes = {
        removedItem: PropTypes.object,
    };

    /* istanbul ignore next */
    constructor(props) {
        super(props);
        this.ref = React.createRef();
    }

    componentDidMount() {
        scrollToElement(this.ref.current);
    }

    render() {
        const { removedItem } = this.props;
        const { name, imageURL, url } = removedItem.product;
        const navigateToPDP = (e) => {
            e.preventDefault();
            navigateToPDPPageWithoutParams(removedItem);
        };

        if (name) {
            return (
                <div
                    ref={this.ref}
                    className={dt([
                        'mt-6',
                        'text-small',
                        'flex',
                        'text-black',
                        '!p-0',
                        '!pb-6',
                        'border-b',
                        'border-solid',
                        'border-gray-15',
                        'items-start',
                        'smMd:mb-2',
                    ])}
                    data-automation-id="at-cart-item-removed-msg"
                >
                    {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                    <a
                        href={url || '#'}
                        onClick={navigateToPDP}
                        className={dt(['sm:w-[52px]', 'lg:w-16', 'mr-4'])}
                    >
                        <img
                            src={imageURL}
                            alt={name}
                            className={dt(['w-full'])}
                            data-automation-id="view-at-removed-product-image"
                        />
                    </a>
                    <div
                        className={dt([
                            'sm:w-[calc(100%-68px)]',
                            'lg:w-[calc(100%-80px)]',
                            'text-small',
                        ])}
                    >
                        {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                        <a
                            className={dt(['underline', 'text-black'])}
                            role="presentation"
                            href={url || '#'}
                            onClick={navigateToPDP}
                            dangerouslySetInnerHTML={{ __html: name }}
                        />
                        &nbsp; has been removed.
                    </div>
                </div>
            );
        }
        return <></>;
    }
}
